<template>
  <section id="hero">
    <b-carousel id="heroSlide"
      controls
      indicators
      :interval="500000"
      img-width="100%"
      img-height="auto"
      v-model="slide"
    >
      <template v-for="(hero, i) in sections.slides">
        <b-carousel-slide :key="i">
          <b-row slot="img">
            <b-col md="8">
              <img :src="'/static/' + hero.desktop" class="d-block img-fluid w-100" width="1024" height="480" :srcset="'/static/' + hero.mobile + ' 600w, /static/' + hero.desktop + ' 2000w'">
              <h2 class="head" v-html="wrapWords(hero.header)"></h2>
              <h2 class="subhead" v-html="wrapWords(hero.subheader)" :style="captionHeight()"></h2>
            </b-col>
            <b-col md="4">
              <div class="caption" v-html="hero.caption"></div>
            </b-col>
          </b-row>
        </b-carousel-slide>
      </template>
    </b-carousel>
  </section>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Hero',
  data () {
    return {
      sections: this.content.hero,
      slide: 0
    }
  },
  methods: {
    wrapWords: function(str, tmpl) {
      return str.replace(/[^\s\\]+\s|\w+/g, tmpl || "<span>$&</span>");
    },
    captionHeight: function() {
      return 'bottom: ' + $('.caption').height();
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../_variables.scss';

  #hero {
    width: 100%;
  }
  .carousel {
    padding-bottom: 50px;
    @media (min-width: 768px) {
      padding-bottom: 0;
    }
  }
  .carousel-item:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border: 0 solid transparent;
    border-left-width: 0px;
    border-right-width: 70px;
    border-top: 70px solid white;
    z-index: 1;
    @media (min-width: 768px) {
      border-right-width: 300px;
      border-top: 300px solid white;
    }
  }
  .carousel-item:after {
    content: "";
    position: absolute;
    bottom: 140px;
    right: 0;
    border: 0 solid transparent;
    border-right-width: 0px;
    border-left-width: 230px;
    border-bottom: 230px solid white;
    z-index: 1;
    @media (min-width: 768px) {
      border-left-width: 35vw;
      border-bottom: 35vw solid $white;
      right: auto;
      left: 66.666667%;
      margin-left: -35vw;
      bottom: 0;
    }
  }
  .carousel-caption {
    position: static;
    height: 100px;
  }
  img {
    position: relative;
  }
  .head,
  .subhead {
    position: absolute;
    z-index: 10;
    margin-bottom: 0;
  }
  .head {
    top: 0;
    left: 0;
    text-align: left;
    width: 230px;
    border-left: 20px solid $white;
    @media (min-width: 768px) {
      top: 50px;
      left: 50px;
      font-size: 48px;
      width: auto;
      max-width: 400px;
    }
    @media (min-width: 1200px) {
      font-size: 80px;
      max-width: 550px;
    }
  }
  .subhead {
    bottom: 0px;
    right: 0;
    text-align: right;
    width: 280px;
    border-right: 20px solid $white;
    @media (min-width: 768px) {
      font-size: 48px;
      width: auto;
      max-width: 450px;
      bottom: 50px;
    }
    @media (min-width: 1200px) {
      font-size: 80px;
      max-width: 700px;
    }
  }
  .caption {
    height: 130px;
    padding: 15px 0 20px 30px;
    text-align: left;
    border-top: 10px solid black;
    // margin-top: 40px;
    margin: 40px 20px 0 20px;
    font-size: 24px;
    position: relative;
    line-height: 1.16;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 22px;
      background: url(../../static/arrow.svg) no-repeat;
      width: 20px;
      height: 20px;
      @media (min-width: 768px) {
        left: -40px;
        top: 23px;
        width: 60px;
        height: 50px;
        background-size: 50%;
      }
      @media (min-width: 1200px) {
        background-size: 100%;
      }
    }
  }
  @media (min-width: 768px) {
    .carousel-control-prev {
      background: url(../../static/carousel-prev-white.svg) no-repeat;
      top: 50%;
      margin-top: -22px;
    }
    .col-md-4 {
      display: flex;
      align-items: center;
      position: relative;
      .caption {
        max-width: 350px;
        font-size: 22px;
        padding: 15px 35px 20px 0px;
        margin: 10px 20px 0 20px;
        &:after {
          width: 150px;
          left: 0;
          margin-left: -150px;
          content: "";
          background: $black;
          height: 10px;
          position: absolute;
          top: 0;
          margin-top: -10px;
          z-index: 10;
        }
      }
    }
  }
  @media (min-width: 1200px) {
    .col-md-4 {
      .caption {
        max-width: 350px;
        font-size: 40px;
        padding: 15px 15px 20px 30px;
        &:after {
          width: 250px;
          left: 0;
          margin-left: -250px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue